import React, { useState, useRef, useEffect } from 'react';
import { createChart, make_prop_change } from './util';
import { archetypes, regen_hps } from './regen';
import { TableDisplay } from "./Common";

const GROUP_CLASS = 'form-group col-md-2';
const CONTROL_CLASS = 'form-control form-control-sm';

const arch_inputs = [
    {prop: 'name', label: 'Name'},
    {prop: 'base_hp', label: 'Base HP'},
    {prop: 'max_hp', label: 'Max HP'},
    {prop: 'regen', label: 'Regen'},
    {prop: 'regen_tick', label: 'Regen Per Tick'}
    //{prop: '', label: ''},
];

function RegenChart({ data }) {
    const canvas = useRef(null);
    const canvas_style = {
        maxWidth: '800px', height: '600px', backgroundColor: '#FFF'
    };

    const boost_values = Array(101).fill().map((_, ndx) => ndx);

    let datasets = [];
    for (const val of data.vals){
        datasets.push({
            label: val.name + ' @ ' + val.regen + ' regen',
            data: boost_values.map(bst => regen_hps(val.base_hp * (100 + bst) / 100, val.regen, val.regen_tick))
        });
    }

    let values = {
        data: {
            labels: boost_values,
            datasets
        },
        title: 'HP/s regen',
        xLabel: '% +HP',
        yLabel: 'HP/s',
        yMax: 100
    };

    useEffect(() => {
        if(canvas.current)
            createChart(canvas.current.getContext('2d'), values);
    });

    return (
        <canvas ref={canvas} width="800" height="600" style={canvas_style}></canvas>            
    );

}

const ValuesEntry = ({ onAdd, onCancel}) => {
    const [data, setData] = useState({});

    const arch_change = (e) => {
        let arch_name = e.target.value;
        let arch = archetypes.find(val => val.name == arch_name);
        if(!arch) {
            setData({...data, arch});
        }
        let new_data = {...data, arch, ...arch};
        new_data.regen = 140;
        setData(new_data);
    }

    const mk_change = (prop_name) => {
        switch (prop_name) {
            default:
                return make_prop_change(prop_name, data, setData);
        }
    }

    const mk_input = (prop_name, label) => {
        return (
            <div key={prop_name} className={GROUP_CLASS}>
                <label htmlFor={prop_name}>{label}:</label>
                <input type="text" id={prop_name} name={prop_name} className={CONTROL_CLASS}
                    value={data[prop_name] || ''} onChange={mk_change(prop_name)} />
            </div>
        );
    }

    const add_click = (e) => {
        onAdd(data);
    }

    let entries = arch_inputs.map(inp => mk_input(inp.prop, inp.label));

    return (
        <div>
            <div className="card">
            <div className="card-body pt-0">
                <div className="card-header">Regen</div>
                <h5 className="card-title">Presets</h5>
                <div className="form-row">
                <div className={GROUP_CLASS}>
                <label htmlFor="arch">Archetype:</label>
                <select name="arch" id="arch" className='' onChange={arch_change}>
                    <option key='' value=''></option>
                    {archetypes.map(arch => (
                        <option key={arch.name} value={arch.name} selected={arch == data.arch ? true : undefined}>{arch.name}</option>
                    ))}
                </select>
                </div>
                </div>
            <h5 className="card-title">Values</h5>
            <div className="form-row">
            {entries}
            </div>
            <button type="button" className="btn btn-primary" onClick={add_click}>Add</button>
            <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>            </div>
            </div>

        </div>
    );

}

function ValuesDisplay({ vals, onAdd, onRemove }) {
    console.log(vals);
    return (<TableDisplay
        headings={arch_inputs.map(x => x.label)}
        values={vals}
        keys={arch_inputs.map(x => x.prop)}
        name={'Character'}
        onAdd={onAdd}
        onRemove={onRemove} />);
}

export const RegenByHPEntry = () => {
    const default_state = {vals: [], state: 'entry', valid: false};
    const [data, setData] = useState(default_state);

    const cancel = (e) => {
        setData({...data, state: ''});
    }

    if(data.state == 'entry') {
        const val_add = (val) => {
            let new_vals = [...data.vals, val];
            setData({...data, 
                vals: new_vals,
                state: '',
                valid: new_vals.length > 0
            });
        }

        return (
            <div>
                <ValuesEntry onAdd={val_add} onCancel={cancel}/>
            </div>
        );
    }

    if(data.state == 'chart') {
        return (
            <div>
                <RegenChart data={data}/>
                <button type="button" className="btn btn-primary" onClick={cancel}>Back</button>
            </div>
        );
    }

    const add_val = () => {
        setData({...data, state: 'entry'});
    }

    const remove_val = (ndx) => {
        let item = data.vals[ndx];
        const not_item = (thing => thing !== item);
        setData({...data, vals: data.vals.filter(not_item)});
    }

    const go = () => {
        setData({...data, state: 'chart'});
    }

    const reset = () => {
        setData(default_state);
    }

    return (
        <div>
            <ValuesDisplay vals={data.vals} onAdd={add_val} onRemove={remove_val} />
            <button type="button" className="btn btn-primary" disabled={!data.valid} onClick={go}>Generate Chart</button>
            <button type="button" className="btn btn-secondary" onClick={reset}>Reset</button>
        </div>
    );
};